(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance','Principal','Idle','$uibModal','LoginService','$uibModalStack'];
    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance,Principal,Idle,$uibModal,LoginService,$uibModalStack) {
        var vm = this;
        vm.authenticationError = false;
        vm.authenticationErrorMessage = '';
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password =  localStorage.password;
        vm.register = register;
        vm.rememberMe = (localStorage.rememberMe === 'true');
        vm.requestResetPassword = requestResetPassword;
        vm.username = localStorage.username;



        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            if(vm.rememberMe){
                localStorage.username = vm.username;
                localStorage.password = vm.password;
                localStorage.rememberMe = true;
            }else {
                localStorage.username = '';
                localStorage.password = '';
                localStorage.rememberMe = false;
            }
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                vm.identity = Principal.currentIdentity;
                $rootScope.username = Principal.currentIdentity.login;

                if ($state.current.name === 'register' || $state.current.name === 'activate' || $state.current.name === 'forms' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    gotoHome();

                }else if($state.current.name === 'sign-out-home-page')
                {
                    var updFlag = Principal.currentIdentity.userPasswordUpdFlag;
                    if(updFlag){
                        gotoChangePassword();
                    }else{
                        gotoHome();
                    }
                }
                //$rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function (error) {
            	if(error.data != null && error.data.AuthenticationException != null
            			&& error.data.AuthenticationException != 'Bad credentials') {
            		vm.authenticationErrorMessage = error.data.AuthenticationException + '.';
            	} else {
            		vm.authenticationErrorMessage = 'Please check your credentials and try again.';
            	}

                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }

        function gotoHome() {

        	var adminAuthorities = ['Administrators'];
        	Principal.hasAuthority(Principal.findHasAnyAuthority(adminAuthorities)).then(function(result) {
                vm.isAdmin = result;

                if (vm.isAdmin === true && Principal.isAuthenticated()) {
                    $state.go('home-main.important-announcements', {}, {
                        reload: true
                    });
                }
                else if (vm.isAdmin === false && Principal.isAuthenticated()) {
                    $state.go('user-home-page', {}, {
                        reload: true
                    });
                }
        	});
        }

        function gotoChangePassword(){
            $state.go('password', {}, {
                reload: true
            });
        }
    }
})();
